import createConverter from './lib/create_converter';
import User from 'models/user';

export default createConverter(User);



// WEBPACK FOOTER //
// ./src/scripts/adapters/immutable_converters/user_converter.js